import WebcamSharingButton from './WebcamSharing';

import { useMytaverseEvent } from '../../../providers';
import { useModal } from '@hooks/modal';
import {
  useHomeBottomButtonsVisibility,
  useShowInitialMuteModal,
} from './hooks';

import MicButton from '@core/dashboard/components/HomeBottomBar/MicButton';
import ScreenShareButton from '@core/dashboard/components/HomeBottomBar/ScreenShareButton';
import RaiseHandButton from '@core/dashboard/components/HomeBottomBar/RaiseHandButton';
import PersonViewToggleButton from '../PersonViewToggleButton';
import TrainerTools from '@features/TrainerTools';

const HomeBottomButtonOptions = () => {
  const { currentEvent } = useMytaverseEvent();

  const {
    showWebcamButton,
    showMicButton,
    showScreenShareButton,
    showRaiseHandButton,
    showToggleViewButton,
    showTrainerTools,
  } = useHomeBottomButtonsVisibility();

  const initialMuteModalData = useModal();

  useShowInitialMuteModal({
    eventId: currentEvent?.eventId || '',
    initialMuteModalData,
  });

  return (
    <>
      {showWebcamButton ? <WebcamSharingButton /> : null}

      {showMicButton ? <MicButton /> : null}

      {showScreenShareButton ? <ScreenShareButton /> : null}

      {showRaiseHandButton && <RaiseHandButton />}
      {showToggleViewButton && <PersonViewToggleButton />}
      {showTrainerTools && <TrainerTools />}
    </>
  );
};

export default HomeBottomButtonOptions;
